export default "__VITE_ASSET__XwKtvr_3__"